import { OptionalLink } from '../01-core/OptionalLink';
import { TextReveal } from '../03-molecules/TextReveal';

export interface DistributorItemProps {
  /** The label */
  label: string;
  /** Link */
  href?: string;
  /** Optional click handler */
  onClick?: () => void;
}

export interface DistributorProps {
  /** The title */
  title: string;
  /** List of items */
  items?: DistributorItemProps[];
}

/** Block rendering a distributor */
export const Distributor = ({ title, items }: DistributorProps) => {
  return (
    <div className="distributor">
      {title && (
        <h2 className="distributor__title">
          <TextReveal text={title} />
        </h2>
      )}
      <ul className="distributor__items">
        {items?.map((item, i) => {
          return (
            <li key={i} className="distributor__item">
              <OptionalLink
                button={true}
                href={item.href}
                onClick={item.onClick}
              >
                {item.label}
              </OptionalLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
